import React, { useState } from "react";
import { Box, CssBaseline, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SidebarNav from "./SidebarNav";
import Topbar from "./Topbar";

const drawerWidth = 280;

const AppShell = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />
      <Topbar drawerWidth={drawerWidth} onMenuClick={handleDrawerToggle} />
      <SidebarNav
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        onClose={handleDrawerToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 3 },
          width: { md: `calc(100% - ${drawerWidth}px)` },
          bgcolor: "background.default",
          backgroundImage: (theme) =>
            theme.palette.mode === "dark"
              ? "radial-gradient(circle at top right, rgba(255, 140, 0, 0.16), transparent 45%), radial-gradient(circle at 20% 10%, rgba(4, 106, 56, 0.2), transparent 40%)"
              : "radial-gradient(circle at top right, rgba(122, 75, 117, 0.14), transparent 45%), radial-gradient(circle at 20% 10%, rgba(255, 140, 0, 0.12), transparent 40%)",
          backgroundAttachment: "fixed",
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default AppShell;
